import React, { useState, useEffect } from 'react'
import { MultiSelect } from "react-multi-select-component";
import AsyncSelect from 'react-select/async'

import styled from 'styled-components'
import './style.css'
import { toast } from 'react-toastify'

import ReactQuill from "react-quill"
import 'react-quill/dist/quill.snow.css'

import { useSelector, useDispatch } from 'react-redux'
import { createResources, getAllResources, editResource } from '../../../../pages/features/resources/resourceSlice'

import { getResourceCategory } from '../../../../pages/features/resourcecategory/resourcecategorySlice'
import { getExternalCategory } from '../../../../pages/features/public/publicSlice'

import { getResourceTag } from '../../../../pages/features/resourcetag/resourcetagSlice'

import { TableHeader } from '../../../../components/tableheader'
import { TableData } from './tabledata'
import Spinner from '../../../../components/spinner'

import { Button } from '../../../../components/button'
import axios from 'axios';

const Resources = () => {
  const [addResource, setAddResource] = useState('')
    const [resourceType, setResourceType] = useState('')
    const [resourceCategoryId, setResourceCategoryId] = useState('')
    const [resourceTitle, setResourceTitle] = useState('')
    const [resourceAuthor, setResourceAuthor] = useState('')
    const [resourceDescription, setResourceDescription] = useState('')
    const [resourceRepositoryLink, setResourceRepositoryLink] = useState('')
    const [resourcePublisher, setResourcePublisher] = useState('')
    const [resourcePublishDate, setResourcePublishDate] = useState('')
    const [resourceEditor, setResourceEditor] = useState('')
    const [resourceEdition, setResourceEdition] = useState('')
    const [resourceISBN, setResourceISBN] = useState('')
    const [resourceISSN, setResourceISSN] = useState('')
    const [resourceIssue, setResourceIssue] = useState('')
    const [resourceImprint, setResourceImprint] = useState('')
    const [resourceTagIds, setResourceTagIds] = useState([])
    const [resourceImage, setResourceImage] = useState('');
    const [resourceContacts, setResourceContacts] = useState('')
    const [resourceKeywords, setResourceKeywords] = useState('')
    const [searchTerm, setSearchTerm] = useState('')
    const [searchResult, setSearchResult] = useState([])
    const [resourceKeyword, setResourceKeyword] = useState('')
    const [fileSizeWithinKB, setFileSizeWithinKB] = useState(false)
    const [displayImage, setDisplayImage] = useState('')

    const[imageSize, setImageSize] = useState('')
    const [imageName, setImageName] = useState('')
    const [showFileInfo, setShowFileInfo] = useState(false)

    const formData = new FormData();

    
    formData.append('resourceTitle', resourceTitle)
    formData.append('resourceAuthor', resourceAuthor)
    formData.append('resourceKeyword', resourceKeyword)
    formData.append('resourceDescription', resourceDescription)
    formData.append('resourceRepositoryLink', resourceRepositoryLink)
    formData.append('resourceCategoryId', resourceCategoryId)
    formData.append('resourceTagIds', resourceTagIds)
    formData.append('resourcePublisher', resourcePublisher)
    formData.append('resourcePublishDate', resourcePublishDate)
    formData.append('resourceEditor', resourceEditor)
    formData.append('resourceEdition', resourceEdition)
    formData.append('resourceISBN', resourceISBN)
    formData.append('resourceISSN', resourceISSN)
    formData.append('resourceIssue', resourceIssue)
    formData.append('resourceImprint', resourceImprint)
    formData.append('resourceImage', resourceImage)
    formData.append('resourceContacts', resourceContacts)
    formData.append('resourceType', resourceType)

    


    const [toggleState, setToggleState] = useState(0);
    const toggleTab = (index) => {
        setToggleState(index); 
    }


    const onFileChange = (e) => {

      const resourceImage = e.target.files[0]
      const imageSizeFixed = (resourceImage.size/1024).toFixed(2)
      setImageName(resourceImage.name)
      // console.log(pickedImage);

      
      // console.log(formData.get('file'));

      if(imageSizeFixed >= 1024){
        setImageSize(`Sorry, image size is above stipulated size (1mb)`)
        setFileSizeWithinKB(false)
        
        
      } else {
        setImageSize(`${imageSizeFixed}kb`)
        setFileSizeWithinKB(true)
        // formData.set('resourceImage', resourceImage)

        //readAsDataURL
        const reader = new FileReader()
        reader.onload = function(){

          if(e.target && e.target.files[0]) {

            setDisplayImage(reader.result)
            console.log(reader.result);
            setResourceImage(resourceImage)
            // formData.set("resourceImage", resourceImage)
        //     console.log(formData.get("resourceImage"))
          }
        }

        reader.readAsDataURL(e.target.files[0])

      }

        setShowFileInfo(true)


      
     
         if(e.target && e.target.files[0]) {

        }

      }

      // console.log(imageName);
     

    const handleAddResource = (e) => {
      if(canEdit){
        setCanEdit('')
        setAddResource(false)
        setResourceTitle('')
        } else {
        setAddResource(!addResource)
        }
    }

    const { resources, isLoading, isError, resourceCreatedStatus, isSuccess, message } = useSelector(state => state?.resources);
    const { resourceTag, resourceTagCreatedStatus} = useSelector(state => state?.resourceTag);
    const { resourceCategory, resourceCategoryStatus} = useSelector(state => state?.resourceCategory);
    const { publicResources, publicStatus} = useSelector(state => state?.publicResources);
   
    
    const dispatch = useDispatch();
    const [resourcesState, setResourcesState] = useState(resources || [''])
    const [updateUIWithout, setUpdateUIWithout] = useState(''); //Update UI after deleting
    const [canEdit, setCanEdit] = useState('') //Edit resourceCategory state

    useEffect(() => {
      dispatch(getResourceTag());
  }, [resourceTagCreatedStatus]);

    useEffect(() => {
      dispatch(getExternalCategory());
  }, [publicStatus]);

    
    useEffect(() => {
        dispatch(getResourceCategory());
    }, [resourceCategoryStatus]);


    useEffect(() => {   
      dispatch(getAllResources());
  }, [resourceCreatedStatus]);

  //updateUI without
  useEffect(()=> {
    setResourcesState([...resourcesState.filter((resource) => resource?.id !== updateUIWithout)])
  }, [updateUIWithout])


  const allResourceTag = resourceTag?.map((tag) =>  ({ label: `${tag?.resourceTagName}`, value:`${tag?.resourceTagIds}`}))




    const handleSubmit = (e) => {
        e.preventDefault();

          if(canEdit){
            dispatch(editResource({...formData, resourceId: canEdit}))
            const indexOfEdited = resourcesState.indexOf(resourcesState.find((resource) => resource.resourceId === canEdit))
    
            // const editedCategory = resourceCategoriesState.splice(indexOfEdited, 1)
            // const formData = new FormData();

    
            // formData.append('resourceTitle', resourceTitle)
            // formData.append('resourceAuthor', resourceAuthor)
            // formData.append('resourceKeyword', resourceKeyword)
            // formData.append('resourceDescription', resourceDescription)
            // formData.append('resourceRepositoryLink', resourceRepositoryLink)
            // formData.append('resourceCategoryId', resourceCategoryId)
            // formData.append('resourceTagIds', resourceTagIds)
            // formData.append('resourcePublisher', resourcePublisher)
            // formData.append('resourcePublishDate', resourcePublishDate)
            // formData.append('resourceEditor', resourceEditor)
            // formData.append('resourceEdition', resourceEdition)
            // formData.append('resourceISBN', resourceISBN)
            // formData.append('resourceISSN', resourceISSN)
            // formData.append('resourceIssue', resourceIssue)
            // formData.append('resourceImprint', resourceImprint)
            // formData.append('resourceImage', resourceImage)
            // formData.append('resourceContacts', resourceContacts)
            // formData.append('resourceType', resourceType)
            //Replace old edited category with updated
            // delete faqCategoryData['faqCategoryId']
            resourcesState.splice(indexOfEdited, 1, formData)
    
            setResourcesState(resourcesState)
            // console.log(resourceCategoriesState)
            // setResourceCategoriesState()
    
            setCanEdit('')
    
    
          } else {
            dispatch(createResources(formData))

            const formData = new FormData();

    
            formData.append('resourceTitle', resourceTitle)
            formData.append('resourceAuthor', resourceAuthor)
            formData.append('resourceKeyword', resourceKeyword)
            formData.append('resourceDescription', resourceDescription)
            formData.append('resourceRepositoryLink', resourceRepositoryLink)
            formData.append('resourceCategoryId', resourceCategoryId)
            formData.append('resourceTagIds', resourceTagIds)
            formData.append('resourcePublisher', resourcePublisher)
            formData.append('resourcePublishDate', resourcePublishDate)
            formData.append('resourceEditor', resourceEditor)
            formData.append('resourceEdition', resourceEdition)
            formData.append('resourceISBN', resourceISBN)
            formData.append('resourceISSN', resourceISSN)
            formData.append('resourceIssue', resourceIssue)
            formData.append('resourceImprint', resourceImprint)
            formData.append('resourceImage', resourceImage)
            formData.append('resourceContacts', resourceContacts)
            formData.append('resourceType', resourceType)
          }

          setResourceType('')
          setResourceCategoryId('')
          setResourceTitle('')
          setResourceAuthor('')
          setResourceDescription('')
          setResourceRepositoryLink('')
          setResourcePublisher('')
          setResourcePublishDate('')
          setResourceEditor('')
          setResourceEdition('')
          setResourceISBN('')
          setResourceISSN('')
          setResourceIssue('')
          setResourceImprint('')
          setResourceTagIds('')
          setResourceContacts('')
          setResourceKeyword('')
          setResourceImage('')

          setShowFileInfo(false)


          // if(isError){
          //   toast.error(message)
          // }else if(isSuccess){
          //   toast.success(message)
          // }

        if(isLoading) {
          return <Spinner />;
      }
    }

    //canEdit state watcher
   useEffect(()=> {
    if(canEdit){
      // alert("You can edit now")
      setAddResource(true)

      const resourceToEdit = resourcesState.filter((resource) => resource.resourceId === canEdit)[0]

      setResourceType(resourceToEdit['resourceType'])
      setResourceCategoryId(resourceToEdit['resourceCategoryId'])
      setResourceTitle(resourceToEdit['resourceTitle'])
      setResourceAuthor(resourceToEdit['resourceAuthor'])
      setResourceDescription(resourceToEdit['resourceDescription'])
      setResourceRepositoryLink(resourceToEdit['resourceRepositoryLink'])
      setResourcePublisher(resourceToEdit['resourcePublisher'])
      setResourcePublishDate(resourceToEdit['resourcePublishDate'])
      setResourceEditor(resourceToEdit['resourceEditor'])
      setResourceEdition(resourceToEdit['resourceEdition'])
      setResourceISBN(resourceToEdit['resourceISBN'])
      setResourceISSN(resourceToEdit['resourceISSN'])
      setResourceIssue(resourceToEdit['resourceIssue'])
      setResourceImprint(resourceToEdit['resourceImprint'])
      setResourceTagIds(resourceToEdit['resourceTagIds'])
      setResourceContacts(resourceToEdit['resourceContacts'])
      setResourceKeyword(resourceToEdit['resourceKeyword'])
      setResourceImage(resourceToEdit['resourceImage'])


      
    }
  }, [canEdit])

    useEffect(()=> {
     setResourcesState([...resourcesState.filter((resource) => resource?.resourceAuthor.includes(searchTerm) || resource?.resourceTitle.includes(searchTerm) || resource?.resourceId.includes(searchTerm) || resource?.resourceRepositoryLink.includes(searchTerm))])

    }, [searchTerm])


    
  // handlers
  const onSearchTextInput = (e) => {
      setSearchTerm(e.target.value)
    
  }


  return (
    <Container className='body_cont'>
      
      <PageHeader>
        <h2>Resources</h2>
        <div className='search_bar'>
          <input type="text" placeholder='Search resources' value={searchTerm} onChange={onSearchTextInput} />
          <div onClick={handleAddResource} >
          <Button filled bgColor={'#2A870E'} text={canEdit || addResource ? 'Cancel' : ' + Add'} noIcon reverse />
          </div>
          
        </div>
      </PageHeader>

{addResource ?
      <AddResource>


        <form onSubmit={handleSubmit} encType="multipart/form-data"> 

        
        <SelectResource className='select_resource_cont'>
          
          <span>Select Resource Type</span>
          <div>
            <div>
              <label htmlFor="resourceType">Nigeriana</label>
              <input name='resourceType' id='nigeriana' type="radio" value='internal'  
                onClick={ (e) => {
                toggleTab(1);
                setResourceType(e.target.value)
              }}
              />
            </div>

            <div>
              <label htmlFor="resourceType">Open Access Resources</label>
              <input name='resourceType' type="radio" id='externalResources' value='external' 
                onClick={ (e) => {
                  toggleTab(2);
                  setResourceType(e.target.value)
                  }} />
            </div>
          </div>
          
        </SelectResource>

        {toggleState === 1 ? 
        
        

        <MainForm>
          <div>
            
              <label htmlFor="category">Category</label>
                <select name="resourceCategoryId" id="resourceCategoryId" 
                  onChange={(e) => {setResourceCategoryId(e.target.value)}}>
                  
                    <option value="">Select Category</option>
                  {
                    resourceCategory.map((category) => {
                      return(
                        <option value={category.resourceCategoryId} key={category.resourceCategoryId}>{category.resourceCategoryName} </option>
                      )
                    })
                  }
                </select>
          </div>

          <DividedInput className='divided_input'>
            <div>
              <label htmlFor="resourceTitle">Resource Title*</label>
              <input type="text" id='resourceTitle' name='resourceTitle' value={resourceTitle} onChange={ (e) => setResourceTitle(e.target.value)} placeholder='Enter resource title' required />
            </div>

            <div>
              <label htmlFor="category">Resource Author*</label>
              <input type="text" id='resourceAuthor' name='resourceAuthor' value={resourceAuthor} onChange={ (e) => setResourceAuthor(e.target.value)} placeholder='Enter Author name(s), If more than one author, separate names with (,)' required />
            </div>  
        </DividedInput>


        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourceRepositoryLink">Resource URL</label>
            <input type="url" name='resourceRepositoryLink' id='resourceRepositoryLink' value={resourceRepositoryLink} onChange={ (e) => setResourceRepositoryLink( e.target.value ) } placeholder='Enter resource repository link' />
          </div>  

          <div>
            <label htmlFor="resourceIssue">Resource Issue</label>
            <input type="text" name='resourceIssue' id='resourceIssue' value={resourceIssue} onChange={ (e) => setResourceIssue(e.target.value) } placeholder='Enter resource issue' />
          </div>


        </DividedInput>



        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourcePublisher">Resource Publisher</label>
            <input type="text" name='resourcePublisher' id='resourcePublisher' value={resourcePublisher} onChange={ (e) => setResourcePublisher(e.target.value) } placeholder='Enter publisher name' />
          </div>

          <div>
            <label htmlFor="resourcePublishDate">Publication Year</label>
            <input type="text" name='resourcePublishDate' id='resourcePublishDate' value={resourcePublishDate} onChange={ (e) => setResourcePublishDate(e.target.value) } placeholder='YYYY' />
          </div>  
        </DividedInput>

        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourceEditor">Resource Editor</label>
            <input type="text" name='resourceEditor' id='resourceEditor' value={resourceEditor} onChange={ (e) => setResourceEditor(e.target.value) }  placeholder='Enter editor name(s), If more than one editor, separate names with (,)' />
          </div>

          <div>
            <label htmlFor="resourceEdition">Resource Edition</label>
            <input type="text" name='resourceEdition' id='resourceEdition' value={resourceEdition} onChange={ (e) => setResourceEdition(e.target.value) } placeholder='Enter resource edition' />
          </div>  
        </DividedInput>

        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourceISBN">Resource ISBN</label>
            <input type="text" name='resourceISBN' id='resourceISBN' value={resourceISBN} onChange={ (e) => setResourceISBN(e.target.value) } placeholder='Enter ISBN' />
          </div>

          <div>
            <label htmlFor="resourceISSN">Resource ISSN</label>
            <input type="text" name='resourceISSN' id='resourceISSN' value={resourceISSN} onChange={ (e) => setResourceISSN(e.target.value) } placeholder='Enter ISSN' />
          </div>  
        </DividedInput>

        <DividedInput className='divided_input'>
          
        <div>
            <label htmlFor="resourceTagId">Resource Tags</label>

            {/* <select name="resourceTagId" id="resourceTagId" 
                  onChange={(e) => {setResourceTagId(e.target.value) 
                  console.log(e.target.value)
                
                  }}>
                    <option value="">Select a tag</option>
                 
                  {
                    resourceTag.map((category) => {
                      return(
                        <option value={category.resourceTagId} key={category.resourceTagId}>{category.resourceTagName} </option>
                      )
                    })
                  }
                </select> */}

                <AsyncSelect 
                  loadOptions={( searchValue, callback ) => {
                    setTimeout(() =>{
                      const filteredOptions = allResourceTag.filter((option) =>
                        option.label.toLowerCase().includes(searchValue.toLowerCase())
                       );
                      //  console.log("resourcetags", searchValue, filteredOptions);
                       callback(filteredOptions)
                    }, 2000 )
                }}
                  value={resourceTagIds}
                  onChange={setResourceTagIds}
                  isMulti
                  defaultOptions
                  name='resourceTagIds'
                  id='resourceTagIds'
                />

                {/* <MultiSelect
                  options={allResourceTag}
                  value={resourceTagIds}
                  onChange={setResourceTagIds}
                  labelledBy="Select a tag"
                  style={{ backgroundColor: '#fff', width: '100% !important'}}
                  width= '100% !important'
                /> */}

            {/* <input type="text" name='resourceTagId' id='resourceTagId' value={resourceTagId} onChange={ (e) => setResourceTagId(e.target.value) } placeholder='Enter Tag(s)' /> */}
          </div>  

          <div>
            <label htmlFor="resourceImprint">Resource Imprint</label>
            <input type="text" name='resourceImprint' id='resourceImprint' value={resourceImprint} 
            onChange={ (e) => {
              setResourceImprint(e.target.value);
              
              } } placeholder='Enter resource imprint' />
          </div>  
        </DividedInput>

        {/* <DividedInput className='divided_input'> */}

        <img src="" alt="" />
          
        <UploadFile color={fileSizeWithinKB ? 'green' : 'red'} fileImage={displayImage} showBgImage={`url(${displayImage})`}>
            <label>Publication Thumbnail</label>
            <section>
              <main>
                <label htmlFor="resourceImage" ></label>
                <input 
                  type="file" 
                  id="resourceImage" 
                  name="resourceImage"  
                  accept="image/png, image/jpeg" 
            
                  onChange={onFileChange}

               
                
              />
              </main>
              <aside>
                {
                  showFileInfo ? 
                  
                  <>
                      <div>
                        <small>Name</small>
                        <h4>{imageName}</h4>
                      </div>
                      <div>
                        <small>Size</small>
                        <h4>{imageSize}</h4>
                      </div>

                  </> : null
                }
              </aside>
            </section>
          </UploadFile>
        {/* </DividedInput> */}

          <div>
            <label htmlFor="resourceKeyword">Resource Keywords</label>
            <input type="text" name='resourceKeyword' id='resourceKeyword' value={resourceKeyword} onChange={ (e) => setResourceKeyword(e.target.value) } placeholder='Enter Keywords (keywords should be separated by a ,)' />
          </div>

          <div>
            <label htmlFor="resourceContacts">Resource Contact</label>
            <input type="text" name='resourceContacts' id='resourceContacts' value={resourceContacts} onChange={ (e) => setResourceContacts(e.target.value) } placeholder='Enter Contacts' />
          </div>

          <div>
            <label htmlFor="resourceDescription">Resource Description*</label>
            <ReactQuill
              theme='snow'
              value={resourceDescription}
              onChange={ (e) => {
                setResourceDescription(e)
                // console.log(e);
                // console.log(typeOf e);
                
              } }
              style={{height: '200px', backgroundColor: 'inherit', input: {height: '200px', backgroundColor: '#fff', border: 'none'}}}
              required
            />

          </div>
            {/* <input type="text" id='resourceDescription' value={resourceDescription} onChange={ (e) => setResourceDescription(e.target.value) } placeholder='Enter resource description' /> */}
        </MainForm>

        : (toggleState === 2
          ?
          
          <MainForm>
          <div>
                <label htmlFor="category">Category</label>
                <select name="resourceCategoryId" id="resourceCategoryId" 
                  onChange={(e) => {setResourceCategoryId(e.target.value) 
                  // console.log(e.target.value)
                  // publicResources
                  }}>
                  <option value="">Select Category</option>
                  {
                    publicResources.map((category) => {
                      return(
                        <option value={category.resourceCategoryId} key={category.resourceCategoryId}>{category.resourceCategoryName} </option>
                      )
                    })
                  }
                </select>
          </div>

          <DividedInput className='divided_input'>
            <div>
              <label htmlFor="resourceTitle">Resource Title*</label>
              <input type="text" id='resourceTitle' name='resourceTitle' value={resourceTitle} onChange={ (e) => setResourceTitle(e.target.value)} placeholder='Enter resource title' required />
            </div>

            <div>
              <label htmlFor="category">Resource Author*</label>
              <input type="text" id='resourceAuthor' name='resourceAuthor' value={resourceAuthor} onChange={ (e) => setResourceAuthor(e.target.value)} placeholder='Enter Author name(s), If more than one author, separate names with (,)' required />
            </div>  
        </DividedInput>


        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourceRepositoryLink">Resource URL</label>
            <input type="url" name='resourceRepositoryLink' id='resourceRepositoryLink' value={resourceRepositoryLink} onChange={ (e) => setResourceRepositoryLink( e.target.value ) } placeholder='Enter resource repository link' />
          </div>  

          <div>
            <label htmlFor="resourceIssue">Resource Issue</label>
            <input type="text" name='resourceIssue' id='resourceIssue' value={resourceIssue} onChange={ (e) => setResourceIssue(e.target.value) } placeholder='Enter resource issue' />
          </div>


        </DividedInput>



        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourcePublisher">Resource Publisher</label>
            <input type="text" name='resourcePublisher' id='resourcePublisher' value={resourcePublisher} onChange={ (e) => setResourcePublisher(e.target.value) } placeholder='Enter publisher name' />
          </div>

          <div>
            <label htmlFor="resourcePublishDate">Publication Year</label>
            <input type="text" name='resourcePublishDate' id='resourcePublishDate' value={resourcePublishDate} onChange={ (e) => setResourcePublishDate(e.target.value) } placeholder='YYYY' />
          </div>  
        </DividedInput>

        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourceEditor">Resource Editor</label>
            <input type="text" name='resourceEditor' id='resourceEditor' value={resourceEditor} onChange={ (e) => setResourceEditor(e.target.value) }  placeholder='Enter editor name(s), If more than one editor, separate names with (,)' />
          </div>

          <div>
            <label htmlFor="resourceEdition">Resource Edition</label>
            <input type="text" name='resourceEdition' id='resourceEdition' value={resourceEdition} onChange={ (e) => setResourceEdition(e.target.value) } placeholder='Enter resource edition' />
          </div>  
        </DividedInput>

        <DividedInput className='divided_input'>
          <div>
            <label htmlFor="resourceISBN">Resource ISBN</label>
            <input type="text" name='resourceISBN' id='resourceISBN' value={resourceISBN} onChange={ (e) => setResourceISBN(e.target.value) } placeholder='Enter ISBN' />
          </div>

          <div>
            <label htmlFor="resourceISSN">Resource ISSN</label>
            <input type="text" name='resourceISSN' id='resourceISSN' value={resourceISSN} onChange={ (e) => setResourceISSN(e.target.value) } placeholder='Enter ISSN' />
          </div>  
        </DividedInput>

        <DividedInput className='divided_input'>
          
        <div>
            <label htmlFor="resourceTagId">Resource Tags</label>

            {/* <select name="resourceTagId" id="resourceTagId" 
                  onChange={(e) => {setResourceTagId(e.target.value) 
                  console.log(e.target.value)
                
                  }}>
                    <option value="">Select a tag</option>
                 
                  {
                    resourceTag.map((category) => {
                      return(
                        <option value={category.resourceTagId} key={category.resourceTagId}>{category.resourceTagName} </option>
                      )
                    })
                  }
                </select> */}

                <AsyncSelect 
                  loadOptions={( searchValue, callback ) => {
                    setTimeout(() =>{
                      const filteredOptions = allResourceTag.filter((option) =>
                        option.label.toLowerCase().includes(searchValue.toLowerCase())
                       );
                       console.log("resourcetags", searchValue, filteredOptions);
                       callback(filteredOptions)
                    }, 2000 )
                }}
                  value={resourceTagIds}
                  onChange={setResourceTagIds}
                  isMulti
                  defaultOptions
                  name='resourceTagIds'
                  id='resourceTagIds'
                />

                {/* <MultiSelect
                  options={allResourceTag}
                  value={resourceTagIds}
                  onChange={setResourceTagIds}
                  labelledBy="Select a tag"
                  style={{ backgroundColor: '#fff', width: '100% !important'}}
                  width= '100% !important'
                /> */}

            {/* <input type="text" name='resourceTagId' id='resourceTagId' value={resourceTagId} onChange={ (e) => setResourceTagId(e.target.value) } placeholder='Enter Tag(s)' /> */}
          </div>  

          <div>
            <label htmlFor="resourceImprint">Resource Imprint</label>
            <input type="text" name='resourceImprint' id='resourceImprint' value={resourceImprint} 
            onChange={ (e) => {
              setResourceImprint(e.target.value);
              
              } } placeholder='Enter resource imprint' />
          </div>  
        </DividedInput>

        {/* <DividedInput className='divided_input'> */}

        <img src="" alt="" />
          
          <UploadFile color={fileSizeWithinKB ? 'green' : 'red'} fileImage={displayImage} showBgImage={`url(${displayImage.toString()})`}>
            <label>Publication Thumbnail</label>
            <section>
              <main>
                <label></label>
                <input 
                  type="file" 
                  id="resourceImage" 
                  name="resourceImage"  
                  accept="image/png, image/jpeg" 
            
                  onChange={onFileChange}

               
                
              />
              </main>
              <aside>
                {
                  showFileInfo ? 
                  
                  <>
                      <div>
                        <small>Name</small>
                        <h4>{imageName}</h4>
                      </div>
                      <div>
                        <small>Size</small>
                        <h4>{imageSize}</h4>
                      </div>

                  </> : null
                }
              </aside>
            </section>
          </UploadFile>
        {/* </DividedInput> */}

          <div>
            <label htmlFor="resourceKeyword">Resource Keywords</label>
            <input type="text" name='resourceKeyword' id='resourceKeyword' value={resourceKeyword} onChange={ (e) => setResourceKeyword(e.target.value) } placeholder='Enter Keywords (keywords should be separated by a ,)' />
          </div>

          <div>
            <label htmlFor="resourceContacts">Resource Contact</label>
            <input type="text" name='resourceContacts' id='resourceContacts' value={resourceContacts} onChange={ (e) => setResourceContacts(e.target.value) } placeholder='Enter Contacts' />
          </div>

          <div>
            <label htmlFor="resourceDescription">Resource Description*</label>
            <ReactQuill
              theme='snow'
              value={resourceDescription}
              onChange={ (e) => {
                setResourceDescription(e)
                // console.log(e);
                // console.log(typeOf e);
                
              } }
              style={{height: '200px', backgroundColor: 'inherit', input: {height: '200px', backgroundColor: '#fff', border: 'none'}}}
              required
            />

          </div>
       
        </MainForm> 
        :null)

      }
        
        <div className='publish'>
        <div className='note'>Note: Fields marked with * are required.</div>
          <Button filled bgColor={'#2A870E'} text={'Publish'} noIcon reverse />
        </div>
        </form>
        
      </AddResource>
:
null
}

<section>
        <TableHeader resourceTitle={'Resource Title'} authorName={'Authors'} resourceUrl={'Resource URL'} resourceDesc={''} datePublished={'Date Published'} />
         { resourcesState.length > 0 ? (
          
          <>
           {
              resourcesState?.slice(0, 20).map((resource) => {

                return (
                <TableData resource={resource} key={resource.resourceId} setUpdateUIWithout={setUpdateUIWithout} setCanEdit={setCanEdit}
               
                />               
                  )
                })
            }    
          
          </>

         ) : ( <h4>You have not created any resource</h4> )

         }

                       

</section>


    </Container>
  )

    
}


export const Container = styled.section`
  padding-top: 40px;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;

  @media only screen and (max-width: 760px){
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
  }

`

const PageHeader = styled.div`

  @media only screen and (max-width: 760px){
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      margin-bottom: 10px;

      @media only screen and (max-width: 760px){
        text-align: left !important;
        align-self: flex-start;
      }
    }

    .search_bar {
      width: 100%;

      input {
        width: 90% !important;

       
      }
    }

    
  }

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  & > div{
    display: flex;
    height: 40px;

    & > input{
      /* outline: none; */
      padding: 1rem;
      background-color: inherit;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
    }

    & button{
      padding: 1rem;
      margin-left: 1rem;
      /* width: 50px; */
    }
  }
`

const AddResource = styled.div`
  padding: 35px 25px 0;
  border: 1px solid #D0D5DD;
  margin-top: 30px;
  margin-bottom: 30px;

  & form {


    & > :last-child{
      margin-top: 3rem;
      border-top: 1px solid #D0D5DD;
      align-self: flex-end;
      padding: 1rem 0;
    }
    & button{
      padding: 1rem;
      margin-left: 1rem;
      align-self: flex-end;
      /* margin-top: 3rem; */

      /* border: 1px solid red; */

      /* width: 50px; */
    }
  }
`

const SelectResource = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (min-width: 200px) and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  

  & > span{
    font-size: 14px;
    font-weight: 500;

    @media only screen and (min-width: 200px) and (max-width: 600px) {
      text-align: left;
  }
  }
  
  & > div{
    display: flex;
    margin-left: 2rem;
    flex-wrap: wrap;

    @media only screen and (min-width: 200px) and (max-width: 600px) {
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-between
  }
  

    & div{
    display: flex;
    align-items: center;

    @media only screen and (min-width: 200px) and (max-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
  }
  

    & > label{
      font-weight: 500;
      color: #667085;
    }

    & > input{
      margin-right: 10px;
      margin-left: 1rem;
    }
  }

  }

`

const MainForm = styled.div`


  & > div{

    display: flex;
    flex-direction: column;
    width: 100% !important;

    & > label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 45px;
      margin-bottom: 0.8rem;
      /* color: #667085; */
    }

    &  select{
      background-color: inherit;
      border-radius: 4px;
      height: 44px;
      width: 100% !important;
      padding: 1rem;
      border: 1px solid #D0D5DD;

      &> option{
        border-radius: 4px;
        width: 100%;
      }
    }

    & > input{
      background-color: inherit;
      width: 100%;
      height: 44px;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      width: 100% !important;
      
  }
  }
`

const DividedInput = styled.section`
 

  & > div{
    /* height: 44px; */
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: 47%;

    &  select{
      background-color: inherit;
      border-radius: 4px;
      height: 44px;
      padding: 1rem;
      border: 1px solid #D0D5DD;
      width: 100% !important;

      &> option{
        border-radius: 4px;
        
      }
    }

    & > input{
      background-color: inherit;
      height: 44px;
      padding: 1rem;
      border-radius: 4px;
      border: 1px solid #D0D5DD;
      width: 100% !important;
      
  }



  &  label{
      font-size: 14px;
      font-weight: 500;
      margin-top: 10px;
      margin-bottom: 5px;

    }

  }
`


const UploadFile = styled.div`
    section {
      width: 100%;
      display: flex;
      align-items: center;

      aside {
        div:nth-child(2) {
          h4 {
            color: ${(props)=> props.color}
          }
        }
      }

      main {
        margin-right: 50px;
        input {
          display: none;
        }

        label {
          display: block;
          width: 80px;
          height: 80px;
          position: relative;
          border-radius: 5%;
          background: ${(props) => props.fileImage ? props.showBgImage : 'green'};
          background-size: cover;
          background-position: center top;
          background-repeat: no-repeat;
          cursor: pointer;
          overflow: hidden;

    
          &:before {
            position: absolute;
            content: "+";
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 4rem;
            background: rgba(0,0,0,0.5)
          }
      }
    }

    
  }

`

export {Resources}